/** Feedback rápido ao coletar Essence ("+2 Power" na cor da essência). */
import { events } from "../core/Events";
import { i18n } from "../i18n/i18n";
import { ESSENCE_COLOR, ESSENCE_I18N } from "../essence/EssenceTypes";

export class EssenceToast {
  private readonly layer: HTMLDivElement;

  constructor(uiRoot: HTMLElement) {
    this.layer = document.createElement("div");
    this.layer.className = "essence-toasts";
    uiRoot.appendChild(this.layer);
    events.on("essence:collected", (p) => this.show(p.type, p.amount));
  }

  private show(type: keyof typeof ESSENCE_COLOR, amount: number): void {
    const el = document.createElement("div");
    el.className = "essence-toast";
    el.style.color = "#" + ESSENCE_COLOR[type].toString(16).padStart(6, "0");
    el.textContent = i18n.t("essence.collected", { n: amount, name: i18n.t(ESSENCE_I18N[type]) });
    this.layer.appendChild(el);
    window.setTimeout(() => el.remove(), 1200);
  }
}
